import { usePortfolioSelection } from 'portfolio/store/hooks';
import { getIndexEventsStreamRequestInfoForPortfolioSelectionAndWidgetConfig } from '../stream-config';
import { useAppSelector } from 'store/hooks';
import { selectIndexEventsRequestDataState } from '../store/data/dataSlice';
import { useMemo } from 'react';
import { useIndexEventsConfigSlice } from '../store/config/configSlice';

export function useIndexEventsWidgetData() {
    const portfolioSelection = usePortfolioSelection();
    const { config } = useIndexEventsConfigSlice();

    const uid = useMemo(() => {
        const requestInfo =
            getIndexEventsStreamRequestInfoForPortfolioSelectionAndWidgetConfig(
                portfolioSelection,
                config
            );

        return requestInfo?.payloadUid;
    }, [portfolioSelection, config]);

    return useAppSelector((state) =>
        selectIndexEventsRequestDataState(state, uid)
    );
}
